<template>
  <div>
    <viewTable
      ref="viewTable"
      :limits="limits"
      :columns-property="columnsProperty"
      :filter="filter"
      module="basic"
      url="fm/calendarMain"
      @addOrEdit="addEditHandle"
      @delete="deleteHandle"
      @reset="resetHandle"
    >
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="日历编码">
            <el-input v-model.trim="filter.calendarCode" placeholder="请输入日历编码" clearable />
          </el-form-item>
          <el-form-item label="日历名称">
            <el-input v-model.trim="filter.calendarName" placeholder="请输入日历名称" clearable />
          </el-form-item>
          <el-form-item label="日历类型">
            <el-select v-model="filter.calendarType" placeholder="请选择日历类型" clearable>
              <el-option v-for="item in calendarTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="filter.calendarStatus" placeholder="请选择状态" clearable>
              <el-option v-for="item in calendarStatusOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
        </el-form>
      </template>
    </viewTable>
    <CalendarEdit ref="calendarEdit" @save-success="loadData" />
  </div>
</template>

<script>
import viewTable from "@/components/ViewTable.vue";
import CalendarEdit from "./CalendarEdit";

export default {
  components: { viewTable, CalendarEdit },
  data() {
    return {
      limits: {
        addAuth: this.$auth(161),
        editAuth: this.$auth(162),
        delAuth: this.$auth(163),
      },
      calendarTypeOptions: [
        { label: "工厂日历", value: 1 },
        { label: "车间日历", value: 2 },
        { label: "产线日历", value: 3 },
        { label: "设备资源日历", value: 4 },
        { label: "班组日历", value: 5 },
      ],
      calendarStatusOptions: [
        { label: "禁用", value: 0 },
        { label: "启用", value: 1 },
      ],
      filter: {
        calendarCode: "",
        calendarName: "",
        calendarType: null,
        calendarStatus: null,
      },
      columnsProperty: [
        { tooltip: true, key: "calendarCode", width: 140, align: "center" },
        { tooltip: true, key: "calendarName", minWidth: 150 },
        { tooltip: true, key: "calendarType", width: 120, align: "center" },
        { tooltip: true, key: "calendarStatus", width: 80, align: "center" },
        { key: "action", align: "center", width: 100, slot: "action" },
      ],
    };
  },
  methods: {
    loadData(pageNum) {
      this.$refs.viewTable.loadData(pageNum);
    },
    addEditHandle(row) {
      this.$refs.calendarEdit.open(row);
    },
    deleteHandle(row) {
      this.$http.delete("basic", "fm/calendarMain", row.id).then((resp) => {
        if (resp.success) {
          this.$message.success("删除成功");
          this.loadData();
        }
      });
    },
    resetHandle(filter) {
      this.filter = Object.assign(this.filter, filter);
    },
  },
};
</script>
